import { SidePanel } from '@/components/SidePanel/SidePanel';
import IntlMessages from '@/components/utility/intlMessages';
import { RegisterForm } from './components/register-form';

function SignUp() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-[35%_1fr] h-[calc(100vh-70.22px)] overflow-hidden">
      <div className="overflow-y-auto">
        <div className="flex flex-col gap-y-5 m-6 md:m-10 py-10">
          <h3 className="text-xl">
            <IntlMessages id="page.signUpTitle" />
          </h3>
          <RegisterForm />
        </div>
      </div>
      <div className="md:shadow-[inset_rgba(0,0,0,0.05)_0px_4px_10px_0px] overflow-y-auto h-full">
        <SidePanel />
      </div>
    </div>
  );
}

export default SignUp;
